var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"anon-bar"},on:{"click":_vm.onTap}},[_vm._v(" Warning: This account has not been claimed. Tap here to register. ")])}
var staticRenderFns = []

export { render, staticRenderFns }